<template>
  <base-modal v-if="showModal" class="modal-convincing-partner-stores" required>
    <template v-slot:content>
      <div class="convincing-partner-stores">
        <div class="content-wrapper">
          <h6 class="title">
            {{ title }}
          </h6>
          <p>
            Com o saldo da lista de presentes do Casar.com você pode comprar
            produtos para sua casa nas maiores lojas do Brasil e ainda ganhar
            <strong class="has-text-primary">4% de cashback</strong> em cada
            compra.
          </p>
          <p>
            <strong
              >Aproveite as ofertas exclusivas dos nossos parceiros no Shopping
              Casar.com</strong
            >
          </p>
        </div>

        <BasePartnersShopping class="partners" />

        <div class="footer-wrapper">
          <a
            @click="close()"
            href="/carteira?go=shopping"
            target="_blank"
            class="button-know-shopping button is-primary"
          >
            Conhecer o Shopping Casar.com!
          </a>
          <button @click="close()" type="button" class="button-quit">
            Vou ficar com a minha lista externa mesmo
          </button>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import GiftsApi from '@/lib/api/Gifts'
import BaseModal from '@/components/BaseModal.vue'
import BasePartnersShopping from '@/components/Gift/BasePartnersShopping.vue'

const STORES = [
  'Camicado',
  'Polishop',
  'Magazine Luiza',
  'Casas Bahia',
  'Ponto Frio',
  'Fast Shop',
  'Extra',
]

export default {
  props: {
    externalList: Array,
  },

  components: {
    BaseModal,
    BasePartnersShopping,
  },

  data() {
    return {
      showModal: false,
      surveyType: 'lista_externa_shopping',
      storeName: '',
      title: '',
    }
  },

  computed: {
    ...mapGetters({
      wedId: 'app/getWedId',
      logonToken: 'app/logonToken',
    }),

    hasAlreadyAnswered() {
      return (
        JSON.parse(
          sessionStorage.getItem('shownModalConvencingPartnerStores')
        ) ?? false
      )
    },

    stores() {
      return this.externalList.filter((list) => list.name)
    },

    storesNames() {
      return this.stores
        .map((list) => list.name)
        .join(', ')
        .toLowerCase()
    },

    partnerStores() {
      return this.externalList.filter(
        (store) => STORES.filter((partner) => partner === store.name).length
      )
    },
  },

  methods: {
    async open() {
      if (!this.hasAlreadyAnswered) {
        const shownToday = await this.getTodayAnswer()
        if (!shownToday) {
          this.setTitle()
          this.showModal = true
        }
      }
    },

    setTitle() {
      if (this.stores.length === 1 && this.partnerStores.length === 1) {
        const storeName = this.partnerStores[0].name
        switch (storeName) {
          case 'Camicado':
          case 'Polishop':
          case 'Magazine Luiza':
          case 'Casas Bahia':
          case 'Fast Shop':
            this.title = `A ${storeName} é parceira do Shopping Casar.com!`
            setTimeout(() => (this.showModal = true), 1000)
            break
          default:
            this.title = `O ${storeName} é parceiro do Shopping Casar.com!`
            setTimeout(() => (this.showModal = true), 1000)
            break
        }
      } else if (this.stores.length > 1 && this.partnerStores.length) {
        this.title =
          'O Casar.com tem parceria com as lojas da sua lista externa!'
      } else {
        this.title = 'O Casar.com tem parceria com as maiores lojas do Brasil!'
      }
    },

    async close() {
      await this.saveSurvey()
      this.showModal = false
    },

    getTodayAnswer() {
      const giftsApi = new GiftsApi(this.logonToken)
      return giftsApi
        .getGiftsUserSurveysByType(this.surveyType)
        .then((surveys) => {
          if (surveys.length) {
            const lastSurveyDate = surveys[surveys.length - 1].data
            const lastDate = new Date(lastSurveyDate).setHours(0, 0, 0, 0)
            const today = new Date().setHours(0, 0, 0, 0)

            return lastDate >= today
          }
          return false
        })
        .catch(() => false)
    },

    async saveSurvey() {
      const data = {
        tipo: this.surveyType,
        resposta: this.storesNames,
      }

      const giftsApi = new GiftsApi(this.logonToken)

      giftsApi.saveGiftsListsSurvey(data).then((response) => {
        if (response)
          sessionStorage.setItem('shownModalConvencingPartnerStores', true)
      })
    },
  },
}
</script>

<style lang="scss">
.modal-convincing-partner-stores {
  padding: 0 16px;
  .c-base-modal__wrapper {
    @include position(absolute, 50%, 0, auto, 0, -50%);
    max-width: 600px;
    width: calc(100% - 30px);
    border-radius: 16px;
    overflow: hidden;
    overflow-y: auto;
  }
}

.convincing-partner-stores {
  max-width: 600px;
  width: 100%;
  padding: 32px 0 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top left;
  background-image: url('~@/assets/img/gifts/external-gift-list/convincing-partner-stores/fundo-shopping.png');
  @media screen and (min-width: 480px) {
    padding: 64px 0 0;
    background-size: auto;
  }

  .content-wrapper {
    padding: 32px 16px;
    margin: 0 8px;
    text-align: left;
    background-color: #fff;
    @media screen and (min-width: 480px) {
      padding: 32px;
      margin: 0 32px;
    }

    .title {
      margin: 0 0 12px;
      font-size: 24px;
      font-weight: bold;
      color: #4b535d;
      @media screen and (min-width: 480px) {
        font-size: 28px;
        margin-bottom: 18px;
      }
    }

    p {
      margin-bottom: 16px;
      font-size: 14px;
      color: #4b535d;
      @media screen and (min-width: 768px) {
        font-size: 18px;
        margin-bottom: 32px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    strong {
      color: #4b535d;
    }
  }

  .partners {
    margin-bottom: 53.5px;
  }

  .footer-wrapper {
    padding: 19px 20px 20px;
    margin-top: 15px;
    font-size: 16px;
    color: #000000;
    text-align: center;
    overflow: visible !important;
    background-color: #ffe3ec;

    .button-know-shopping {
      display: inline-flex;
      min-height: 43px;
      height: 100%;
      width: auto;
      padding-left: 16px;
      padding-right: 16px;
      margin-top: -40px;
      font-size: 16px;
      white-space: pre-wrap;
    }

    .button-quit {
      display: inline-block;
      width: 100%;
      max-width: 320px;
      font-size: 14px;
      color: #393939;
      border: none;
      cursor: pointer;
      background-color: transparent;
    }
  }
}
</style>
